import React from 'react'
import { CostItem } from '../CostItem'

type Props = {
  value: number
}

export const EstimatedFees = ({ value }: Props) => {
  return <CostItem name="Estimated payment processing fees" value={value} negative />
}
